module.exports = __webpack_public_path__ + "static/media/Tigrex.79fe8644.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Tigrex.png
// module id = 144
// module chunks = 0